























import { defineComponent } from "@vue/composition-api";
import { ROLES } from "@/const";
import BasePage from "@/components/BasePage";
import LocaleSwitch from "@/components/LocaleSwitch";
import LoginComponent from "@/components/LoginComponent";
import SiteLogo from "@/components/SiteLogo";

export default defineComponent({
  name: "PageLogin",
  components: { LocaleSwitch, SiteLogo, BasePage, LoginComponent },
  props: {
    role: { type: String, default: ROLES.MEMBER },
  },
});
